import { teamsModel } from '../../../../../../features/teams';
import { integrationsApi } from '../../../../../../shared/api';
import { call, select } from 'redux-saga/effects';
import { getFullUrl } from '../../../../../../shared/lib';

export function* requestHubspotToken(code: string) {
  const { id: teamId } = yield select(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const callbackUrl = getFullUrl('auth-callback');

  yield call(integrationsApi.requestHubspotAccessToken, {
    code,
    redirectUri: callbackUrl,
    teamId,
  });
}
